import * as React from 'react';
require('./style.css');
const classNames = require('classnames');

const PAGETITLE_USAGE = {
	page: '',
	centeredPage: 'pageTitleCentered',
};

interface IProps {
	usage?: 'page' | 'centeredPage';
	title?: string;
	titleAdditionalData?: string;
	titleContent?: any;
}

/**
 *
 * @param props
 */
export const PageTitle = (props: IProps) => {
	let titleElement = <h1>{props.title}</h1>;
	if (props.titleAdditionalData) {
		titleElement = (
			<h1>
				{props.title}
				<span className="gray"> {props.titleAdditionalData}</span>
			</h1>
		);
	}

	const usage = props.usage ? PAGETITLE_USAGE[props.usage] : PAGETITLE_USAGE.page;
	return (
		<div className={classNames('pageTitle', usage)}>
			{titleElement}
			<div className="rightContent">{props.titleContent}</div>
			<div className="clear" />
		</div>
	);
};
